import React, { useEffect, useState } from "react"
import Application from "services/applications/Application.service"
import BaseApplicationView from "pages/Application/View/index"

let appService = null
let plasticsUser = null
appService = new Application(JSON.parse(localStorage.getItem("authUser")))
plasticsUser = appService.getStrategy("officer")



const ViewApplication = props => {
  const [viewComponent, setviewComponent] = useState()
  const [currentPath, setcurrentPath] = useState(
    window.location.pathname + props.location.search
  )

  // useEffect(() => {
  //   console.log(props)
  //   plasticsUser = appService.getStrategy("officer")
  //   appService
  //     .getApplicationDetails(2)
  //     .then(response => {
  //       if (response.status) {
  //         //setviewComponent(<BaseApplicationView appDetails={response.data} />)
         
  //         // staff comments
  //         // let lenHist = response.data.application_flow_histories.length

  //         // setcomments(
  //         //   response.data.application_flow_histories[lenHist - 1]
  //         //     .comment_to_applicant
  //         // )
  //         // setreason(
  //         //   response.data.application_flow_histories[lenHist - 1].reason
  //         // )

  //       }
  //       console.log("app_data", response.data)
  //     })
  // }, [])

  useEffect(()=>{
    var isRecalled = false
    if (currentPath.includes("dg-recall-approved-application")) {
      var isRecalled = true
    }

      appService
      .getApplicationDetails(props.location.search.split("=")[1])
      .then(response => {
        if (response.status) {
          setviewComponent(<BaseApplicationView recallApplication={isRecalled} appDetails={response.data} />)

        }
      })
  }, [])
  
  return (
    <>
    {viewComponent}
    </>
  )
}

export default ViewApplication
